<template>
    <div>
        <p>This is the Settings view</p>
    </div>
</template>        

<script>
export default {
    name: 'BuildingsSettingsView',
    components: {
    }
}
</script>